// import React from 'react'
import styled from 'styled-components'
// import media from '../../../utils/style'

export const ButtonGroupEl = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  margin: -8px;

  > div {
    padding: 8px;
  }

  img {
    opacity: 70%;
    transition: opacity 0.5s cubic-bezier(0.19, 1, 0.22, 1);

    &:hover {
      opacity: 100%;
    }
  }
`
